export default "__VITE_ASSET__D1tpOYzI__"